<template>
  <div class="documents">
    <m-create-document
      title="Добавить документ"
      :active="isShowCreateDocumentModal"
      :current-document-id="currentDocumentIdCreateDocumentModal"
      @close="closeModalCreateDocument"
      @submitDocument="submitDocument"
    />
    <c-loader v-if="isLoadingArchive" label="Загружаем архив с документами" :active="isLoadingArchive" height="fixed" />

    <div
      v-if="!isDataLoading"
      class="documents-need-add"
      :class="{
        'documents-need-add-hide': !isCloseAllDocumentSuccessMessage && documentsNeedAddedGroupItems.length === 0,
      }"
    >
      <div class="documents-need-add-title">
        <button
          v-if="documentsNeedAddedGroupItems.length > 0"
          v-b-toggle="'documents-need-add-docs-group-collapse'"
          class="documents-need-add-title-button"
        >
          <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z"
              fill="#0066FF"
            />
            <path
              d="M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z"
              fill="#0066FF"
            />
          </svg>
        </button>
        Необходимо добавить
      </div>
      <b-collapse id="documents-need-add-docs-group-collapse" visible>
        <div
          v-for="group in documentsNeedAddedGroupItems"
          :key="`group-${group.name}`"
          class="documents-need-add-docs-group"
        >
          <template v-if="documentsNeedAddedGroupItems.length > 0">
            <div class="documents-need-add-docs-group-title">{{ group.name }}</div>
            <div
              v-for="document in group.items"
              :key="`document-${document.id}`"
              class="documents-need-add-docs-group-item"
            >
              <c-button
                v-if="userHavePermissionAddEditDocument()"
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  content: 'Добавить документ',
                  placement: 'top',
                }"
                class="documents-need-add-docs-group-item-add"
                size="small"
                :icon="{ icon: 'plus', color: 'primary' }"
                @click="openModalCreateDocument(document.id)"
              />
              <div class="documents-need-add-docs-group-item-name" :title="document.name">{{ document.name }}</div>
            </div>
          </template>
        </div>
        <transition name="fade">
          <div
            v-if="documentsNeedAddedGroupItems.length === 0"
            class="documents-need-add-all-added"
            @click="isCloseAllDocumentSuccessMessage = false"
          >
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z"
                fill="#12C971"
              />
              <path
                d="M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z"
                fill="#12C971"
              />
            </svg>
            <div class="documents-need-add-all-added-message">
              <div class="documents-need-add-all-added-message-text">Все обязательные документы добавлены</div>
              <button class="documents-need-add-all-added-message-close">Закрыть</button>
            </div>
          </div>
        </transition>
      </b-collapse>
    </div>

    <div
      v-if="!isDataLoading && errorText === null"
      class="documents-content"
      :class="{
        'documents-content-not-need-documents-add':
          !isCloseAllDocumentSuccessMessage && documentsNeedAddedGroupItems.length === 0,
      }"
    >
      <div class="documents-content-header">
        <c-switcher
          v-model="switcherLocal"
          class="finance__switcher h-switcher"
          type="group"
          :items="[
            { label: 'Действующие', value: 'acting_documents' },
            { label: 'Архив', value: 'archive_documents' },
          ]"
        />
        <div class="documents-content-header-buttons">
          <c-button
            class="documents-content-header-buttons-archive"
            size="small"
            :responsive="true"
            :disabled="archiveButtonIsDisabled"
            icon="box-arhive"
            type="with-icon"
            :label="archiveButtonLabel"
            @click="changeArchiveStatus"
          />
          <c-button
            class="documents-content-header-buttons-download"
            size="small"
            :responsive="true"
            :disabled="isDisabledDownloadArchiveDocumentsButton"
            icon="download"
            type="with-icon"
            label="Скачать одним архивом"
            @click="exportDocumentsToArchive(switcherLocal === 'acting_documents' ? 0 : 1)"
          />
          <c-button
            v-if="switcherLocal === 'acting_documents' && userHavePermissionAddEditDocument()"
            class="documents-content-header-buttons-add-document"
            size="small"
            :responsive="true"
            :icon="{ icon: 'plus', color: 'primary' }"
            type="with-icon"
            label="Добавить документ"
            @click="openModalCreateDocument(null)"
          />
        </div>
      </div>
      <div class="documents-content-table">
        <c-data-table-personal-employee-documents
          v-if="!isTableLoading && !isDataLoading && switcherLocal === 'acting_documents'"
          id="actingDocuments"
          ref="table"
          class="documents-content-table-table"
          :sorted-column="sortedColumn"
          empty-records-label="Документы пока не добавлены"
          :levels="1"
          :disabled-columns="[]"
          :data="tableDataActingDocuments"
          :with-mass-operations="true"
          @sortedEvent="refreshTable"
          @onCheckboxesChanged="onTableCheckboxesChanged"
          @changeArchiveStatusSingle="changeArchiveStatusSingle"
        />
        <c-data-table-personal-employee-documents
          v-if="!isTableLoading && !isDataLoading && switcherLocal === 'archive_documents'"
          id="archiveDocuments"
          ref="table"
          class="documents-content-table-table"
          empty-records-label="Документы пока не добавлены"
          :levels="1"
          :disabled-columns="[]"
          :sorted-column="sortedColumn"
          :data="tableDataArchiveDocuments"
          :with-mass-operations="true"
          @sortedEvent="refreshTable"
          @onCheckboxesChanged="onTableCheckboxesChanged"
          @changeArchiveStatusSingle="changeArchiveStatusSingle"
        />
        <c-loader
          v-if="isTableLoading"
          class="documents-content-table-loader"
          label="Данные загружаются"
          :active="isTableLoading"
          height="280"
        />

      </div>
    </div>
    <c-loader
      v-if="isDataLoading"
      class="documents-loader"
      label="Данные загружаются"
      :active="isDataLoading"
      height="500"
    />
    <div class="documents-content">
      <c-error-feedback
        v-if="errorText !== null && !isDataLoading"
        :text="errorText"
      />
    </div>
    <u-confirm id="archive-doc" ref="confirm" />
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Button from "@/components/controls2/Button";
import Switcher from "@/components/controls2/Switcher";
import DataTablePersonalEmployee from "@/pages/personal-employee/additions/data-table-personal-employee";
import DocumentsCreateEditDocumentModal from "@/pages/personal-employee/additions/modals/documents-create-edit-document-modal";
import Loader from "@/components/loader";
import ErrorFeedback from "@/components/error-feedback.vue";

// helpers
import { declOfNum } from "@/helpers/workWIthWords";
import Confirm from "../../documents/u-confirm.vue";

export default {
  name: "personal-employee-documents",
  components: {
    "c-button": Button,
    "c-switcher": Switcher,
    "c-data-table-personal-employee-documents": DataTablePersonalEmployee,
    "m-create-document": DocumentsCreateEditDocumentModal,
    "c-loader": Loader,
    "c-error-feedback": ErrorFeedback,
    "u-confirm": Confirm,
  },
  data() {
    return {
      isLoadingArchive: false,
      isDataLoading: false,
      isTableLoading: false,
      switcherLocal: this.$route.query.tab ? this.$route.query.tab : "acting_documents",
      isShowCreateDocumentModal: false,
      currentDocumentIdCreateDocumentModal: null,
      documentsNeedAddedGroupItems: [],
      isCloseAllDocumentSuccessMessage: true,
      isDisabledDownloadArchiveDocumentsButton: true,
      errorText: null,
      isDisabledArchiveButton: true,
      tableDataActingDocuments: {
        type: "documents-acting-documents",
        columns: [],
        records: [],
        actions: true,
        isGroupByCategory: 1,
        enabledFields: [],
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
      },
      tableDataArchiveDocuments: {
        type: "documents-archive",
        columns: [],
        records: [],
        actions: true,
        isGroupByCategory: 1,
        enabledFields: [],
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
      },
      sortedColumn: {
        sortBy: this.$route.query.sortBy ? this.$route.query.sortBy : "created",
        sortType: this.$route.query.sortType ? this.$route.query.sortType : "desc",
      },
    };
  },
  computed: {
    ...mapGetters("personalEmployee", ["getTableColumnsDocuments"]),

    ...mapGetters(["getUserPermissions"]),

    archiveButtonLabel() {
      return this.switcherLocal === 'archive_documents' ? 'Восстановить из архива' : 'Переместить в архив';
    },

    archiveButtonIsDisabled() {
      return this.isDisabledArchiveButton || (this.switcherLocal === "acting_documents" ? !this.tableDataActingDocuments.records.length : !this.tableDataArchiveDocuments.records.length);
    },

    checkedRecords() {
      const currentTableData = this.switcherLocal === "acting_documents" ? this.tableDataActingDocuments : this.tableDataArchiveDocuments;
      const ids = [];
      currentTableData.records.forEach(group => {
        group.records.forEach(record => {
          if (record.checkbox) ids.push(record.documentId);
        });
      });
      return ids;
    }
  },
  watch: {
    switcherLocal(value) {
      if (value === "acting_documents") {
        this.getTableDocuments(0);
        this.getRequiredDocumentsList(0)
      } else {
        this.getTableDocuments(1);
        this.getRequiredDocumentsList(1)
      }

      this.isDisabledArchiveButton = true;
    },
  },
  async created() {
    this.isDataLoading = true;
    this.tableDataActingDocuments.columns = this.getTableColumnsDocuments.map((column) => {
      column.isSorted = column.id === this.sortedColumn.sortBy;
      return column;
    });
    this.tableDataArchiveDocuments.columns = this.getTableColumnsDocuments.map((column) => {
      column.isSorted = column.id === this.sortedColumn.sortBy;
      return column;
    });

    if (this.switcherLocal === "acting_documents") {
      this.getTableDocuments(0);
      this.getRequiredDocumentsList(0);
    } else {
      this.getTableDocuments(1);
      this.getRequiredDocumentsList(1);
    }
  },
  methods: {
    changeArchiveStatus() {
      this.$refs.confirm.open(
        {
          title: this.switcherLocal === "acting_documents" ? "Перенос документов в архив" : "Перенос документов из архива",
          confirmText: "Перенести",
          text: this.switcherLocal === "acting_documents" ? "Выбранные документы будут перенесены в архив." : "Выбранные документы будут перенесены из архива.",
        },
        () => {
          this.isTableLoading = true;
          this.$store.dispatch("personalEmployee/moveToArchive", {ids: this.checkedRecords})
            .then(res => {
              if(res.success) {
                this.getRequiredDocumentsList(this.switcherLocal === "acting_documents" ? 0 : 1);
                this.getTableDocuments(this.switcherLocal === "acting_documents" ? 0 : 1);
                this.isDisabledArchiveButton = true;
              }
              this.showPopupMessage(res.message, res.success);
            })
            .finally(()=>{
              this.isTableLoading = false;
            });
        },
      );
    },
    
    changeArchiveStatusSingle(id) {
      this.isTableLoading = true;
      this.$store.dispatch("personalEmployee/moveToArchive", {ids: [id]})
        .then(res => {
          if(res.success) {
            this.getRequiredDocumentsList(this.switcherLocal === "acting_documents" ? 0 : 1);
            this.getTableDocuments(this.switcherLocal === "acting_documents" ? 0 : 1);
            this.isDisabledArchiveButton = true;
          }
          this.showPopupMessage(res.message, res.success);
        })
        .finally(()=>{
          this.isTableLoading = false;
        });
    },

    showPopupMessage(message, success) {
      this.$notify({
        group: success ? "success-message" : "error-message",
        data: {
          textMessage: message,
        },
      });
    },

    onTableCheckboxesChanged(state) {
      this.isDisabledArchiveButton = !state;
    },

    userHavePermissionAddEditDocument() {
      return this.getUserPermissions.includes("updateWorkerDocuments");
    },

    getTableDocuments(isArchive) {
      this.isTableLoading = true;

      const workerId = this.$route.params.id;
      this.$store.dispatch("personalEmployee/getWorkerDocuments", {
        workerId,
        isArchive,
        sortBy: this.sortedColumn.sortBy,
        sortType: this.sortedColumn.sortType,
      })
        // eslint-disable-next-line consistent-return
        .then((res) => {
          if (!res.response) {
            this.isDataLoading = false;
            this.isTableLoading = false;
            this.errorText = "Произошла ошибка, попробуйте позже";
            return false;
          }
          this.tableDataActingDocuments.records = [];
          this.tableDataArchiveDocuments.records = [];
          let records = [];
          this.isDisabledDownloadArchiveDocumentsButton = true;

          Object.entries(res.response).forEach(([key, value]) => {
            let isHaveDocumentsExpired = false;
            let isHaveExpirationDate = false;

            records = value.map((record) => {
              if (record.file_list !== null && record.file_list.length > 0)
                this.isDisabledDownloadArchiveDocumentsButton = false;
              if (!isHaveDocumentsExpired && record.expired) isHaveDocumentsExpired = true;
              if (!isHaveExpirationDate && record.expire_soon) isHaveExpirationDate = true;

              return {
                documentId: record.doc_id,
                documentTypeId: record.doc_type_id,
                doc_type: {
                  value: record.doc_name,
                },
                deadline: {
                  value: record.deadline,
                },
                files: {
                  value: record.file_list !== null && record.file_list.length > 0 ?
                    `${record.file_list.length} ${declOfNum(record.file_list.length, ["файл", "файла", "файлов"])}` :
                    "",
                  items: record.file_list,
                },
                created: {
                  value: record.created,
                },
                comment: record.comment,
                expired: record.expired,
                expireSoon: record.expire_soon,
                isShowRow: true,
                checkbox: false,
              };
            });
            if (isArchive === 0) {
              this.tableDataActingDocuments.records.push({
                isHaveDocumentsExpired,
                isHaveExpirationDate,
                categoryName: key,
                records,
              });
            } else {
              this.tableDataArchiveDocuments.records.push({
                isHaveDocumentsExpired,
                isHaveExpirationDate,
                categoryName: key,
                records,
              });
            }
          });

          this.$router.replace({
            name: "personal-employee-documents",
            query: {
              sortBy: this.sortedColumn.sortBy,
              sortType: this.sortedColumn.sortType,
              tab: this.switcherLocal,
            },
          }).catch(() => {
          });

          setTimeout(() => {
            this.isTableLoading = false;
          }, 300);

          setTimeout(() => {
            this.isDataLoading = false;
          }, 500);
        });
    },

    getRequiredDocumentsList(isArchive) {
      console.log(isArchive)
      const workerId = this.$route.params.id;
      this.documentsNeedAddedGroupItems = [];
      this.$store.dispatch("personalEmployee/getListRequiredDocuments", {workerId, isArchive}).then((res) => {
        Object.entries(res.response).forEach(([groupName, documentItems]) => {
          this.documentsNeedAddedGroupItems.push({
            name: groupName,
            items: documentItems,
          });
        });
      });
    },

    exportDocumentsToArchive(isArchive) {
      this.isLoadingArchive = true;
      const workerId = this.$route.params.id;

      this.$store.dispatch("personalEmployee/getLinkOnDocumentsDownload", {
        workerId,
        isArchive,
        ids: this.checkedRecords
      }).then((res) => {
        if (typeof res.response === "object") {
          setTimeout(() => {
            this.isLoadingArchive = false;
          }, 300);
        } else {
          const urlToArchive = window.location.origin + res.response;
          const link = document.createElement("a");
          link.download = `Документы_${moment().format("DD_MM_YYYY")}.zip`;
          link.href = urlToArchive;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setTimeout(() => {
            this.isLoadingArchive = false;
          }, 300);
        }
      }).catch(() => {
        console.log("При попытке скачать файл произошла ошибка");
        setTimeout(() => {
          this.isLoadingArchive = false;
        }, 300);
      }).finally(() => {
        ids = [];
      });
    },

    refreshTable(e) {
      this.sortedColumn.sortType = e.sortType;
      this.sortedColumn.sortBy = e.sortBy;
      if (this.switcherLocal === "acting_documents") {
        this.getTableDocuments(0);
        this.getRequiredDocumentsList(0)
      } else {
        this.getTableDocuments(1);
        this.getRequiredDocumentsList(1)
      }
    },

    submitDocument(documentId) {
      this.documentsNeedAddedGroupItems.forEach((group, groupIndex) => {
        group.items.forEach((doc, docIndex) => {
          if (doc.id === documentId) {
            this.documentsNeedAddedGroupItems[groupIndex].items.splice(docIndex, 1);
          }
          if (this.documentsNeedAddedGroupItems[groupIndex].items.length === 0) {
            this.documentsNeedAddedGroupItems.splice(groupIndex, 1);
          }
        });
      });
      if (this.switcherLocal === "acting_documents") {
        this.isTableLoading = true;
        setTimeout(() => {
          this.getTableDocuments(0);
          this.getRequiredDocumentsList(0)
        }, 300);
      }
    },

    openModalCreateDocument(documentId) {
      if (this.switcherLocal === "archive_documents") {
        this.switcherLocal = "acting_documents";
      }
      this.currentDocumentIdCreateDocumentModal = documentId;
      this.isShowCreateDocumentModal = true;
    },

    closeModalCreateDocument() {
      this.currentDocumentIdCreateDocumentModal = null;
      this.isShowCreateDocumentModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.documents {
  display: flex;
  margin-top: 40px;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }

  &-need-add {
    display: flex;
    flex-direction: column;
    max-width: 268px;
    width: 100%;
    transition: all 0.4s ease-out;

    &-hide {
      opacity: 0;
      max-width: 0;
      max-height: 0 !important;
      max-width: 0 !important;

      & .documents-need-add-title {
        font-size: 0 !important;
        line-height: 0 !important;
        max-width: 0 !important;
      }
    }

    @media screen and (max-width: 1024px) {
      max-width: 100%;
    }

    &-title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;

      @media screen and (max-width: 700px) {
        font-size: 15px;
        line-height: 18px;
      }

      &-button {
        display: none;
        margin-right: 12px;
        justify-content: center;
        background: #ffffff;
        align-items: center;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        outline: none;
        border: 1px solid #dfe4ef;
        box-sizing: border-box;

        &[aria-expanded="true"] svg {
          transform: rotate(180deg);
        }

        @media screen and (max-width: 768px) {
          display: flex;
        }
      }
    }

    &-docs-group {
      margin-top: 15px;
      display: flex;
      flex-direction: column;

      @media screen and (max-width: 700px) {
        margin-top: 17px;
      }

      &-title {
        font-weight: 500;
        font-size: 13px;
        line-height: 100%;
        color: #8e9cbb;
        margin-bottom: 14px;
      }

      &-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border-top: solid 1px #dfe4ef;

        @media screen and (max-width: 700px) {
          margin-left: -20px;
          width: calc(100% + 40px);
          padding: 8px 20px;
        }

        &:last-child {
          border-bottom: solid 1px #dfe4ef;
        }

        &-add {
          width: 22px !important;
          height: 22px !important;

          ::v-deep & .c-button-icon {
            width: 10px !important;
            height: 10px !important;
            margin-left: -5px !important;
            margin-top: -5px !important;
          }
        }

        &-name {
          display: flex;
          align-items: center;
          margin-left: 12px;
          font-size: 13px;
          line-height: 120%;
          max-width: 100%;
          text-overflow: ellipsis;
          overflow-x: hidden;
          display: inline-block;
        }
      }
    }

    &-all-added {
      margin-top: 8px;
      background: #d0f4e3;
      display: flex;
      align-items: flex-start;
      border-radius: 6px;
      height: auto;
      width: 100%;
      padding: 22px 21px 22px 27px;

      @media screen and (max-width: 1024px) {
        height: auto;
        align-items: center;
      }

      @media screen and (max-width: 450px) {
        height: 96px;
        padding: 20px;
        margin-left: -20px;
        width: calc(100% + 40px);
        border-radius: 0;
        align-items: flex-start;
      }

      & svg {
        margin-top: 3px;
        width: 14px !important;
        min-width: 14px !important;
        height: 10px !important;
        min-height: 10px !important;

        @media screen and (max-width: 1024px) {
          margin-top: 0;
        }

        @media screen and (max-width: 450px) {
          margin-top: 3px;
        }
      }

      &-message {
        margin-left: 12.5px;
        display: flex;
        flex-direction: column;

        @media screen and (max-width: 1024px) {
          flex-direction: row;
        }

        @media screen and (max-width: 450px) {
          max-width: 245px;
          flex-direction: column;
        }

        &-text {
          font-size: 13px;
          line-height: 120%;
        }

        &-close {
          border: none;
          font-size: 13px;
          line-height: 120%;
          padding: 0;
          margin: 8px 0 0 0;
          color: #0066ff;
          width: 51px;
          background: transparent;

          &:focus {
            outline: none;
          }

          @media screen and (max-width: 1024px) {
            margin: 0 0 0 12.5px;
          }

          @media screen and (max-width: 450px) {
            margin: 8px 0 0 0;
          }
        }
      }
    }
  }

  &-content {
    transition: all 0.4s ease-out;
    max-width: 862px;
    width: 100%;
    margin-left: 30px;

    &-not-need-documents-add {
      transition: all 0.4s ease-out;
      margin-left: 0;
      max-width: 1128px;

      //&::v-deep .documents-actions {
      //  justify-content: center;
      //
      //  @media screen and (max-width: 700px) {
      //    justify-content: flex-start;
      //  }
      //}

      @media screen and (max-width: 1024px) {
        margin: 0 !important;
      }
    }

    @media screen and (max-width: 1024px) {
      margin: 40px 0 0 0;
      max-width: 100%;
    }

    @media screen and (max-width: 768px) {
      margin: 32px 0 0 0;
    }

    @media screen and (max-width: 700px) {
      margin: 23px 0 0 0;
    }

    &-header {
      display: flex;
      justify-content: space-between;

      @media screen and (max-width: 700px) {
        flex-direction: column;
      }

      &-switcher {
        @media screen and (max-width: 700px) {
          width: 100%;
        }

        ::v-deep & .c-switcher-group {
          @media screen and (max-width: 700px) {
            width: 100%;
          }
        }

        ::v-deep & .c-switcher-group .c-switcher-group-item {
          @media screen and (max-width: 700px) {
            width: 50%;
          }
        }
      }

      &-buttons {
        display: flex;
        align-items: center;
        margin-left: 9px;

        @media screen and (max-width: 700px) {
          align-self: flex-end;
          margin-top: 20px;
        }

        &-archive {
          margin-right: 9px;
        }

        &-download {
          //margin-left: auto;
        }

        &-add-document {
          margin-left: 9px;
        }
      }
    }

    &-table {
      margin-top: 28px;

      @media screen and (max-width: 700px) {
        margin-top: -4px;
      }

      &-table {
        width: 100%;

        @media screen and (max-width: 700px) {
          width: calc(100% + 40px);
          max-width: calc(100% + 40px);
        }

        ::v-deep .c-table__cell {
          white-space: nowrap;
        }

        ::v-deep .c-table__shadow {
          display: none !important;
        }
      }

      &-loader {
        max-width: 1127px;

        @media screen and (max-width: 700px) {
          margin-top: 20px;

          ::v-deep & .loader-overlay {
            width: calc(100% + 40px);
            left: -20px;
            border-right: none;
            border-left: none;
          }
        }
      }
    }
  }

  &-loader {
    max-width: 1200px;
    width: 100%;

    @media screen and (max-width: 700px) {
      ::v-deep & .loader-overlay {
        width: calc(100% + 40px);
        left: -20px;
        border-right: none;
        border-left: none;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
